import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    List,
    ListItem,
    ListItemText,
    Box
} from "@mui/material";
import { useTranslation } from "react-i18next";

// Use translated weekday names
const useWeekdayOptions = (t) => ([
    { value: 0, label: t("weekdayNames.0") },
    { value: 1, label: t("weekdayNames.1") },
    { value: 2, label: t("weekdayNames.2") },
    { value: 3, label: t("weekdayNames.3") },
    { value: 4, label: t("weekdayNames.4") },
    { value: 5, label: t("weekdayNames.5") },
    { value: 6, label: t("weekdayNames.6") }
]);

const formatDate = (iso) => {
    if (!iso) return "";
    const [y, m, d] = iso.split("-");
    return `${d}-${m}-${y}`;
};

const ConfirmAddDialog = ({ open, onClose, onConfirm, items }) => {
    const { t } = useTranslation("confirmAddDialog");
    const weekdayOptions = useWeekdayOptions(t);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            
            <DialogTitle>{t("title")}</DialogTitle>

            <DialogContent dividers>
                <Box mb={2}>
                    {t("message")}
                </Box>

                <List dense>
                    {items.map((item, idx) => (
                        <ListItem key={idx}>
                            <ListItemText
                                primary={
                                    `${weekdayOptions[item.weekDay].label}: `
                                    + `${item.openTime} - ${item.closeTime}`
                                }
                                secondary={`${t("validFrom")} ${formatDate(item.validFrom)} → ${formatDate(item.validTo)}`}
                            />
                        </ListItem>
                    ))}
                </List>
            </DialogContent>

            <DialogActions>
                <Button variant="outlined" onClick={onClose}>
                    {t("cancel")}
                </Button>

                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        onConfirm();
                        onClose();
                    }}
                >
                    {t("confirm")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmAddDialog;
